import { createBrowserHistory } from "history";

export const historyContext = createBrowserHistory();
